<template>
  <div>
    <img :src="src">
    <b-container>
      <b-row>
        <b-col>
          <b-button @click="generate"> {{$tr('button.genetate','Generate')}}</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import Rpc from "@/Rpc";

export default {
  name: "AITest",

  mounted() {
  },
  methods: {

    async generate() {
      DialogManager.openPendingDialog("Generacja");
      try {
        let task = await Rpc.ai.AiImageOperations.generateProduct("xx", "xx");
        let file = await task.finish();
        this.src = file.url;
      } finally {
        DialogManager.closePendingDialog();
      }

    }
  },
  data() {
    return {
      src: "",
    }
  }
}
</script>